import { Alert } from "@smart/itops-sb-design-system-dom";

import { useBannersVisibility } from "../../hooks";
import { getUITranslation } from "../../utils";

export const LanguageBanner = ({
  isTeamHidden,
  selectedLanguage,
}: {
  isTeamHidden?: boolean;
  selectedLanguage?: string;
}) => {
  const bannersVisibility = useBannersVisibility();

  const content = getUITranslation(
    isTeamHidden ? "languageBannerBelow" : "languageBannerAbove",
    selectedLanguage,
  );

  return (
    bannersVisibility &&
    bannersVisibility.visibility.LANGUAGE && (
      <Alert
        palette="default"
        content={content}
        onClose={() => bannersVisibility.close("LANGUAGE")}
      />
    )
  );
};
